import { Injectable } from '@angular/core';

/**
 * Signal sonore « nouvelle commande gérée » (spec §7.1) — deux bips courts
 * via Web Audio, sans asset. Silencieux tant que le navigateur n'a pas eu
 * de geste utilisateur (AudioContext suspendu) ou hors navigateur.
 */
@Injectable({ providedIn: 'root' })
export class OrderChime {
  private context: AudioContext | null = null;

  play(): void {
    const context = this.contextOrNull();
    if (context === null || context.state !== 'running') {
      return;
    }
    const start = context.currentTime;
    this.beep(context, 880, start, 0.12);
    this.beep(context, 1175, start + 0.16, 0.18);
  }

  private beep(context: AudioContext, frequency: number, at: number, duration: number): void {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, at);
    gain.gain.exponentialRampToValueAtTime(0.25, at + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, at + duration);
    oscillator.connect(gain).connect(context.destination);
    oscillator.start(at);
    oscillator.stop(at + duration + 0.05);
  }

  private contextOrNull(): AudioContext | null {
    if (this.context !== null) {
      return this.context;
    }
    if (typeof window === 'undefined' || typeof window.AudioContext !== 'function') {
      return null;
    }
    this.context = new window.AudioContext();
    // Politique autoplay : reprise au premier geste utilisateur.
    const resume = (): void => {
      void this.context?.resume();
    };
    window.addEventListener('pointerdown', resume, { once: true });
    window.addEventListener('keydown', resume, { once: true });
    return this.context;
  }
}
